type HeaderProps = {
  logoSrc: string;
  alt?: string;
};

function Header({ logoSrc, alt = "Logo" }: HeaderProps) {
  return (
    <header className="flex justify-center">
      <img src={logoSrc} alt={alt} className="h-6 w-auto" />
    </header>
  );
}

export default Header;
